import leaflet, { LatLng, LeafletEvent, LeafletMouseEvent } from 'leaflet';

interface ISimulatedEvent extends MouseEvent {
  _simulated: boolean;
}

export class CircleMarkerEditorEx extends leaflet.Editable.CircleMarkerEditor {
  addHooks(): this {
    super.addHooks();
    if (this.feature) {
      this.initVertexMarkers(undefined);
    }
    return this;
  }

  initVertexMarkers(latlng?: LatLng): void {
    if (!this.enabled()) {
      return;
    }
    this.addVertexMarker(latlng || this.getLatLng());
  }

  getLatLng(): LatLng {
    return this.feature.getLatLng();
  }

  addVertexMarker(latlng: LatLng): void {
    new this.tools.options.vertexMarkerClass(latlng, [latlng], this);
  }

  onVertexMarkerClick(e: LeafletEvent): void {
    leaflet.Editable.makeCancellable(e);
    // Fired when a `click` is issued on a vertex, before any internal action is being processed.
    this.fireAndForward('editable:vertex:click', e);
    if ('_cancelled' in e && e._cancelled) {
      return;
    }
    if (this.tools.drawing() && this.tools._drawingEditor !== this) {
      return;
    }
    this.fireAndForward('editable:vertex:clicked', e);
    this.commitDrawing(e);
  }

  onVertexRawMarkerClick(e: LeafletEvent): void {
    // Fired when a `click` is issued on a vertex without any special key and without being in drawing mode.
    this.fireAndForward('editable:vertex:rawclick', e);
    if ('_cancelled' in e && e._cancelled) {
      return;
    }
  }

  onVertexDeleted(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:deleted', e);
  }

  onVertexMarkerCtrlClick(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:ctrlclick', e);
  }

  onVertexMarkerShiftClick(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:shiftclick', e);
  }

  onVertexMarkerMetaKeyClick(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:metakeyclick', e);
  }

  onVertexMarkerAltClick(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:altclick', e);
  }

  onVertexMarkerContextMenu(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:contextmenu', e);
  }

  onVertexMarkerMouseDown(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:mousedown', e);
  }

  onVertexMarkerMouseOver(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:mouseover', e);
  }

  onVertexMarkerMouseOut(e: LeafletEvent): void {
    this.fireAndForward('editable:vertex:mouseout', e);
  }

  onVertexMarkerDrag(): void {}
  onVertexMarkerDragStart(): void {}
  onVertexMarkerDragEnd(e: LeafletEvent): void {
    this.fireAndForward('editable:circle:vertex:dragend', e);
  }

  onDragStart(e: LeafletEvent): void {
    this.editLayer.clearLayers();
    super.onDragStart(e);
  }

  onDrag(e: LeafletEvent): void {
    this.onMove(e);
    this.fireAndForward('editable:drag', e);
  }

  onDragEnd(e: LeafletEvent): void {
    this.initVertexMarkers(undefined);
    super.onDragEnd(e);
    this.refresh();
  }

  onDrawingMouseUp(e: LeafletMouseEvent): void {
    this.commitDrawing(e);
    (e.originalEvent as ISimulatedEvent)._simulated = false;
    super.onDrawingMouseUp(e);
    this.refresh();
  }

  refresh(): void {
    this.feature.redraw();
    this.onEditing();
  }
}
